import React, { Component } from 'react';
import Helmet from "react-helmet";

import Account from '../../components/account';

// @inject('lineStore')
// @observer
const AccountPage = () => (
	<div className="account-index">
		<Helmet>
			<title>ИРМ - Ваши данные</title>
		</Helmet>
		<Account />
	</div> 
)

export default AccountPage;
 


// WEBPACK FOOTER //
// ./src/routes/account/index.js